import type { ReactElement, ReactNode } from "react";

import styles from "./Quotes.module.css";

type Props = Readonly<{
  children: ReactNode;
  testId?: string;
}>;

export default function Quotes({ children, testId }: Props): ReactElement {
  return (
    <blockquote data-testid={testId} className={styles.quotes}>
      <p>{children}</p>
    </blockquote>
  );
}
